<template>
    <div class="flex flex-wrap gap-0.5">
      <div
          v-for="([country, payoutGroup], index) in payoutGroups"
          :key="'payout-group-' + country"
        >
        <span
          v-if="country == 'null'"
          v-tooltip="getTooltipFromGroup(payoutGroup, country)"
          v-text="`All Geos`"
        ></span>
        <div 
          v-else
        >
          <VTooltip :delay="0">
            <div v-if="useFlags">
              <Flag
                :country="country"
                size="m"
                :class="[
                    payoutGroups.length == index + 1 ? '' : 'mr-1',
                    'rounded-sm overflow-hidden block',
                ]"
              />
            </div>
            <div v-else :class="payoutGroups.length == index + 1 ? '' : 'pr-1'">{{ country }}</div>
            <template #popper>          
              <div class="flex gap-2 items-center">
                <Flag
                    :country="country"
                    size="l"
                    :class="[
                        'rounded-md overflow-hidden block',
                    ]"
                  />
                  <div class="flex flex-col">
                    <span class="text-xxs">
                      {{ payoutGroup[0].country.label }}
                    </span>
                    <span class="text-xxs">
                      {{ getPayoutRangeString(payoutGroup) }}
                    </span>
                  </div>
              </div>
            </template>
          </VTooltip>
          
        </div>
      </div>
    </div>
  </template>
  
  <script setup>
  import { ref, computed } from 'vue';
  import { formatCurrency } from '@/utils/formatCurrency'
  import { getPayoutRangeString } from '@/utils/payoutRange'

  const props = defineProps({
    payoutGroups: {
      type: Array,
      required: true
    },
    useFlags: {
      type: Boolean,
      default: false
    }
  });

  
  const getTooltipFromGroup = (payoutGroup, country) => {
    if(payoutGroup.length == 0) return ''
   
    return getPayoutRangeString(payoutGroup)

  };
  </script>
  
  <style scoped>

  </style>